import styled from 'styled-components'
import { animated } from 'react-spring'

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`

export const Background = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 1s;
  z-index: -1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

export const ScreenWrapper = styled(animated.div)`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`
